/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Toggle_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not change this setting." |
*
* @param {Connections_Toggle_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_toggle_error = /** @type {((inputs?: Connections_Toggle_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Toggle_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Einstellung konnte nicht geändert werden.")
	return /** @type {LocalizedString} */ ("Could not change this setting.")
});